import React from 'react'
import "./VideoComponent.css"

const VideoComponent = ({ videoUrl }) => {
    return (
        <div className="video-container">
            <video width="90%" controls>
                <source src={videoUrl} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default VideoComponent;